/**
 * Display helpers for tenant flag codes.
 *
 * The wizard shows the spelled-out description, not the abbreviation, and
 * drops any trailing parenthetical qualifier — e.g. the flag-codes table
 * has "No Access (per Talon LPE Flag Codes)" / "Not Measured (surfaced by
 * beta-tester gauging datasets)" / "Phase Separated Hydrocarbons (free
 * product)"; the button should just read "No Access" / "Not Measured" /
 * "Phase Separated Hydrocarbons".
 */
export function flagCodeLabel(description: string | null | undefined, code: string): string {
  const cleaned = (description ?? '').split('(')[0].trim();
  return cleaned || code;
}

/** De-dup a flag-code list by display label so two codes that resolve to
 *  the same spelled-out label (e.g. DR + DRY → "Dry") show as one button.
 *  Keeps the first occurrence (callers pass them pre-sorted by code). */
export function dedupeFlagCodes<T extends { code: string; description: string }>(list: T[]): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const fc of list) {
    const key = flagCodeLabel(fc.description, fc.code).toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(fc);
  }
  return out;
}
